/**
 * Dev error logger (GH #24 debugging aid).
 *
 * Surfaces the errors that otherwise vanish into a silent route wedge:
 * a Vue setup/render/watcher throw aborts navigation, leaving the URL
 * changed but the view stuck (a fresh tab works because it reloads the
 * module graph). These hooks print the real stack so the cause is named
 * instead of swallowed. Client + dev only.
 */
export default defineNuxtPlugin((nuxtApp) => {
	if (!import.meta.dev) return;

	nuxtApp.hook('vue:error', (err, _instance, info) => {
		console.error('[vue:error]', info, err);
	});
	nuxtApp.hook('app:error', (err) => {
		console.error('[app:error]', err);
	});

	if (typeof window !== 'undefined') {
		window.addEventListener('unhandledrejection', (e) => {
			console.error('[unhandledrejection]', e.reason);
		});
		window.addEventListener('error', (e) => {
			console.error('[window.error]', e.error ?? e.message);
		});
	}
});
